/**
 * React Track Component
 *
 * @author    Nick Dreckshage <ndreckshage@wayfair.com>
 * @author    Artem Ruts <aruts@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */

import React from 'react';
import PropTypes from 'prop-types';

class TrackMount extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    tracker: PropTypes.object.isRequired,
    once: PropTypes.bool,
    name: PropTypes.string,
    type: PropTypes.string,
    data: PropTypes.object,
    pageView: PropTypes.bool,
  };

  static defaultProps = {
    once: false,
    type: '',
    name: '',
    data: {},
    pageView: false,
  };

  componentDidMount() {
    const {type: eventType, name: actionName, data} = this.props;

    this.props.tracker.track(
      {eventType, actionName, ...data},
      {
        once: this.props.once,
      }
    );
  }

  render() {
    return this.props.children;
  }
}

export default TrackMount;
